var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1316 12.1333C18.8824 11.8083 18.5791 11.5267 18.2974 11.245C17.5716 10.595 16.7483 10.1292 16.0549 9.44667C14.4408 7.865 14.0833 5.25417 15.1124 3.25C14.0833 3.49917 13.1841 4.0625 12.4149 4.68C9.6091 6.93333 8.5041 10.9092 9.82576 14.3217C9.8691 14.43 9.91243 14.5383 9.91243 14.6792C9.91243 14.9175 9.74993 15.1342 9.53327 15.2208C9.2841 15.3292 9.0241 15.2642 8.81827 15.0908C8.75678 15.0393 8.70536 14.9769 8.6666 14.9067C7.44243 13.3575 7.24743 11.1367 8.07076 9.36C6.2616 10.8333 5.27577 13.325 5.4166 15.6758C5.4816 16.2175 5.5466 16.7592 5.73077 17.3008C5.88243 17.9508 6.17493 18.6008 6.49993 19.175C7.66993 21.0492 9.69576 22.3925 11.8733 22.6633C14.1916 22.9558 16.6724 22.5333 18.4491 20.93C20.4316 19.1317 21.1249 16.25 20.1066 13.78L19.9658 13.4983C19.7383 13 19.1316 12.1333 19.1316 12.1333ZM15.7083 18.9583C15.4049 19.2183 14.9066 19.5 14.5166 19.6083C13.3033 20.0417 12.0899 19.435 11.3749 18.72C12.6641 18.4167 13.4333 17.4633 13.6608 16.4992C13.8449 15.6325 13.4983 14.9175 13.3574 14.0833C13.2274 13.2817 13.2491 12.5992 13.5416 11.8517C13.7474 12.2633 13.9641 12.675 14.2241 13C15.0583 14.0833 16.3691 14.56 16.6508 16.0333C16.6941 16.185 16.7158 16.3367 16.7158 16.4992C16.7483 17.3875 16.3583 18.3625 15.7083 18.9583Z",
    fill: "url(#paint0_linear_6592_8353)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6592_8353",
    x1: 12.988,
    y1: 3.25,
    x2: 12.988,
    y2: 22.7494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFAC30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF4B0C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.c4017d2d97780ab6f366c0809eb30e16.svg";
export { ForwardRef as ReactComponent };